import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { AccountSelectError } from '../../components/AccountSelectError';
import { trackLoginAnotherWay, trackLoginNeedHelp } from '../../utils/tracking';
import { HelpContainer } from '../HelpContainer';
export function AccountSelectErrorView(_ref) {
  var retry = _ref.retry,
    backToList = _ref.backToList,
    email = _ref.email;
  var handleRetry = function handleRetry() {
    retry(email);
  };
  var loginAnotherWay = function loginAnotherWay() {
    trackLoginAnotherWay();
    backToList();
  };
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null), /*#__PURE__*/React.createElement(SubtitleLayout, null, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"), /*#__PURE__*/React.createElement(AccountSelectError, {
    onRetry: handleRetry,
    onChangeAccount: loginAnotherWay
  }), /*#__PURE__*/React.createElement(HelpContainer, {
    onClick: trackLoginNeedHelp
  }));
}